import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import _ from 'lodash'
import { Dimmer, Loader, Table, Popup, Label, Button, Statistic, Segment } from 'semantic-ui-react'

import RestaurantActions from '../../../reducers/restaurantReducer'
import DriverActions from '../../../reducers/driverReducer'
import utils from '../../../utils'

import DateFields from '../fields/dateRangeSearchField'
import ReportModal from '../../../components/invoice/ReportModal'
import OrderDetailModal from '../../../lib/OrderDetailModal'

const initialVendorInfo = {
  phone: '',
  vattin: '',
  name: {
    en: '',
    kh: '',
  },
  address: {
    en: '',
    kh: '',
  },
}
class BranchOrders extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      viewOrder: null,
      officialInfo: props.merchant.official_info || initialVendorInfo,
      modalDetailVisible: false,
      modalReportVisible: false,
      rielRate: 4100,
      commissionRate: 10,
      invoiceNumber: '',
      invoiceDate: Number(moment().format('x')),
      startFrom: Number(
        moment()
          .startOf('day')
          .format('x')
      ),
      endAt: Number(
        moment()
          .endOf('day')
          .format('x')
      ),
      branchKey: null,
    }
  }

  componentDidMount() {
    const { startAt, endAt, syncDrivers, driverLoaded, merchant } = this.props

    if (startAt && endAt) {
      this.setState({
        startFrom: moment(startAt),
        endAt: moment(endAt),
      })
    }

    if (!driverLoaded) {
      syncDrivers()
    }

    if (merchant.official_info) {
      this.setState({ officialInfo: merchant.official_info })
    }
  }

  getFilteredOrders = () => {
    const { orders, merchantKey } = this.props
    const { branchKey } = this.state

    const merchantOrders = []
    const orderKeys = Object.keys(orders)
    const orderCount = orderKeys.length

    for (let i = 0; i < orderCount; i += 1) {
      const orderKey = orderKeys[i]
      const order = orders[orderKey]
      const isCurrentMerchantOrder = order.restaurant.key === merchantKey
      const isCurrentBranchOrder = branchKey ? order.restaurant.branch.key === branchKey : true

      if (isCurrentBranchOrder && isCurrentMerchantOrder) {
        merchantOrders.push({ ...order, key: orderKey })
      }
    }

    return merchantOrders
  }

  validateSearchByDate = () => {
    const { startFrom, endAt } = this.state

    if (startFrom > endAt) {
      return false
    }

    return true
  }

  getOrderByDate = () => {
    const { startFrom, endAt } = this.state
    const { getBranchOrders } = this.props

    getBranchOrders(startFrom, endAt)
  }

  onFieldChange = (field, value) => {
    this.setState({ [field]: value })
  }

  onSearch = () => {
    const validDate = this.validateSearchByDate()

    if (validDate) {
      this.getOrderByDate()
    } else {
      alert('Date invalid, please check it again')
    }
  }

  onAllButtonClick = () => {
    const { merchant } = this.props

    this.setState({ branchKey: null, officialInfo: merchant.official_info })
  }

  onBranchButtonClick = branchKey => {
    const { merchant } = this.props
    const officialInfo = _.get(merchant, ['branches', branchKey, 'official_info'], null)

    this.setState({ branchKey, officialInfo })
  }

  renderTimeStampCell = timeStamp => (
    <Table.Cell textAlign="center">
      <span style={{ color: 'rgba(208, 62, 62, 1)' }}>{moment(timeStamp).fromNow()}</span>
      <br />
      {moment(timeStamp).format('HH:mm a')}
      <br />
      {moment(timeStamp).format('DD-MMM-YYYY')}
      <br />
    </Table.Cell>
  )

  renderStatusLabel = status => (
    <Label
      color={utils.helpers.getOrderStatus(status).color}
      style={{ margin: 0, marginBottom: 5, width: 120 }}
    >
      {utils.helpers.getOrderStatus(status).label}
    </Label>
  )

  renderRejectedPopup = order => (
    <Popup trigger={this.renderStatusLabel(order.status)} wide position="top center">
      {order.rejected_description || 'No description'}
    </Popup>
  )

  renderActionCell = order => (
    <Table.Cell textAlign="center">
      {order.status === 'rejected' ? this.renderRejectedPopup(order) : this.renderStatusLabel(order.status)}
      <br />
      <Button
        onClick={() => this.setState({ viewOrder: order, modalDetailVisible: true })}
        size="mini"
        style={{ margin: 0, width: 120 }}
      >
        View Detail
      </Button>
    </Table.Cell>
  )

  renderOrdersTable = orders => {
    return (
      <Table basic style={{ marginTop: 0 }}>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Order Number</Table.HeaderCell>
            <Table.HeaderCell textAlign="center">Branch</Table.HeaderCell>
            <Table.HeaderCell textAlign="center">Ordered At</Table.HeaderCell>
            <Table.HeaderCell textAlign="center">Updated At</Table.HeaderCell>
            <Table.HeaderCell textAlign="center">Actions</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {orders.length > 0 ? (
            orders.map(order => (
              <Table.Row key={order.key}>
                <Table.Cell>{(order ? utils.order.getOrderNumber(order) : '').toUpperCase()}</Table.Cell>
                <Table.Cell textAlign="center">{order.restaurant.branch.name}</Table.Cell>
                {this.renderTimeStampCell(order.created_at)}
                {this.renderTimeStampCell(order.updated_at)}
                {this.renderActionCell(order)}
              </Table.Row>
            ))
          ) : (
            <Table.Row>
              <Table.Cell colSpan={5} textAlign="center">
                No Data available
              </Table.Cell>
            </Table.Row>
          )}
        </Table.Body>
      </Table>
    )
  }

  renderLoading = () => {
    return (
      <Dimmer active inverted>
        <Loader inverted />
      </Dimmer>
    )
  }

  renderStatistics = orders => {
    const orderCount = orders.length

    let successOrderCount = 0
    let inProgressOrderCount = 0
    let rejectedOrderCount = 0
    let subtotal = 0
    let commission = 0
    let promotionDiscount = 0
    let promoCodeDiscount = 0
    let companyPromotion = 0
    let commissionVat = 0

    for (let i = 0; i < orderCount; i += 1) {
      const order = orders[i]

      if (order.status === 'delivered') {
        const { merchantDiscount, voucherDiscount, companyDiscount } = utils.order.getOrderDiscount(order)

        successOrderCount += 1
        subtotal += order.sub_total
        commission += order.sub_total * (order.discount_rate / 100)
        promotionDiscount += merchantDiscount
        promoCodeDiscount += voucherDiscount
        companyPromotion += companyDiscount
      } else if (order.status === 'rejected') {
        rejectedOrderCount += 1
      } else {
        inProgressOrderCount += 1
      }
    }

    const orderItems = [
      {
        key: 'orders',
        label: 'Orders',
        value: orderCount,
      },
      {
        key: 'success-orders',
        label: 'Success Orders',
        value: successOrderCount,
        color: 'green',
      },
      {
        key: 'in-progress-orders',
        label: 'In Progress Orders',
        value: inProgressOrderCount,
        color: 'yellow',
      },
      {
        key: 'rejected-orders',
        label: 'Rejected Orders',
        value: rejectedOrderCount,
        color: 'red',
      },
    ]

    commissionVat = commission * 0.1

    const paymentItems = [
      {
        key: 'subtotal',
        label: 'Sub-Total',
        value: utils.helpers.convertToCurrency(subtotal),
      },
      {
        key: 'commission',
        label: 'Commission',
        value: utils.helpers.convertToCurrency(commission),
      },
      {
        key: 'vat-on-commission',
        label: 'VAT on Commission',
        value: utils.helpers.convertToCurrency(commissionVat),
      },
      {
        key: 'promotion',
        label: 'Merchant Discount',
        value: utils.helpers.convertToCurrency(promotionDiscount),
      },
      {
        key: 'promo-code',
        label: 'Promo Code',
        value: utils.helpers.convertToCurrency(promoCodeDiscount),
      },
      {
        key: 'company-promotion',
        label: 'Company Promotion',
        value: utils.helpers.convertToCurrency(companyPromotion),
      },
    ]

    return (
      <div style={{ marginBottom: 14 }}>
        <Segment>
          <Statistic.Group items={orderItems} widths="four" />
        </Segment>
        <Segment>
          <Statistic.Group items={paymentItems} widths="three" />
        </Segment>
      </div>
    )
  }

  renderBranchSelectButtons = () => {
    const { branchKey } = this.state
    const { merchant } = this.props
    const branches = merchant.branches || {}

    if (_.size(branches) > 1) {
      return (
        <div style={{ marginTop: 14 }}>
          <Button as="a" onClick={this.onAllButtonClick} basic={!!branchKey}>
            All
          </Button>
          {_.map(branches, (branch, key) => (
            <Button
              key={key}
              as="a"
              style={{ marginBottom: 6 }}
              onClick={() => this.onBranchButtonClick(key)}
              basic={branchKey !== key}
            >
              {branch.name}
            </Button>
          ))}
        </div>
      )
    }

    return null
  }

  renderReportModal = () => {
    const { startFrom, endAt, modalReportVisible } = this.state
    const { merchant, orders } = this.props
    const allOrders = _.reduce(
      orders,
      (accum, order) => {
        if (order && order.status === 'delivered') {
          const {
            sub_total: subtotal,
            restaurant: {
              branch: { name: branch_name, key: branch_id },
            },
            restaurant: { name: merchant_name },
          } = order

          accum.push({
            subtotal: subtotal,
            branchId: branch_id,
            branchName: branch_name,
            merchantName: merchant_name,
          })
        }
        return accum
      },
      []
    )

    return (
      <ReportModal
        startFrom={startFrom}
        endAt={endAt}
        orders={allOrders}
        modalReportVisible={modalReportVisible}
        merchant={merchant}
        onFieldChange={this.onFieldChange}
      />
    )
  }

  renderContent = () => {
    const { startFrom, endAt, viewOrder, modalDetailVisible, modalReportVisible } = this.state
    const { branchOrderLoading } = this.props
    const orders = this.getFilteredOrders()

    return (
      <div style={{ height: '100%', overflow: 'auto' }}>
        <div style={{ padding: '0px 14px' }}>
          <DateFields
            loading={branchOrderLoading}
            startFrom={startFrom}
            endAt={endAt}
            onSearch={this.onSearch}
            onFieldChange={this.onFieldChange}
          />
          {this.renderBranchSelectButtons()}
          <Button onClick={() => this.setState({ modalReportVisible: !modalReportVisible })}>INVOICE</Button>
        </div>
        {this.renderReportModal()}
        <div
          style={{
            padding: '14px 14px 0px 14px',
          }}
          className="list-content"
        >
          {this.renderStatistics(orders)}
          {this.renderOrdersTable(orders)}
        </div>
        <OrderDetailModal
          visible={modalDetailVisible}
          onClose={() => this.setState({ modalDetailVisible: false, viewOrder: null })}
          order={viewOrder}
        />
      </div>
    )
  }

  render() {
    const { loading, driverLoading } = this.props

    if (loading || driverLoading) {
      return this.renderLoading()
    }

    return this.renderContent()
  }
}

const mapState = ({ restaurants, drivers }) => ({
  orders: restaurants.branchOrders,
  branchOrderLoading: restaurants.branchOrderLoading,
  startAt: restaurants.startAt,
  endAt: restaurants.endAt,

  driverLoaded: drivers.driverLoaded,
  driverLoading: drivers.driverLoading,
})

const mapDispatch = {
  getBranchOrders: RestaurantActions.getBranchOrders,
  syncDrivers: DriverActions.syncDrivers,
}

export default connect(
  mapState,
  mapDispatch
)(BranchOrders)



// WEBPACK FOOTER //
// ./src/components/restaurants/views/branchOrders.js